(function ($) {
	'use strict';

	/*
	 * Bloqueia o scroll quando o menu estiver aberto
	 */
	$(document).on('touchmove mousewheel DOMMouseScroll', '.box-menu, .overlay-mask', function (e) {
		e.preventDefault();
	});

	/*
	 * Função responsável por ajustar o menu conforme a resolução
	 */
	var ajustarMenu = function () {
		var windowWidth = $(window).width(),
			$abrirMenu = $('.abrir-menu'),
			$boxMenu = $('.box-menu');

		// Quando o tamanho da tela for de 480px ou manor o menu abrirá inteiro na tela
		if (windowWidth <= 480) {
			$abrirMenu.addClass('full-menu');
			$abrirMenu.trigger('blur');
			if ($boxMenu.hasClass('aberto')) {
			    $boxMenu.show();
			    
			} else {
			    $boxMenu.hide();
			    
			}
			$boxMenu.css('right', 0);
		} else {
			$abrirMenu.removeClass('full-menu');
			$abrirMenu.trigger('blur');
			if ($boxMenu.hasClass('aberto')) {
				$boxMenu.css('right', 0);
			} else {
			    $boxMenu.css('right', -355);
			}
			$boxMenu.show();
		}
	};

	/*
	 * Cria um scroll vertical no menu que é ativado
	 * quando o tamanho vertical da tela é menor que o conteudo do menu
	 */
	$('.box-menu').niceScroll();

	// Função de ajuste do menu executada quando o site é carregado
	ajustarMenu();

	// Função de ajuste do menu executada quando a janela é redimensionada
	$(window).resize(function () {
		ajustarMenu();
	});

	var overlayMask = overlayMask || new App.overlayMask('.box-acoes');

	/*
	 * Abre o menu quando NÃO existe a classe "full-menu" no botão responsável por abrir o menu
	 */
	$(document).on('click', '.abrir-menu:not(.full-menu)', function (e) {
	    
	    $('.abrir-menu').toggleClass('open');
		e.preventDefault();

		var $boxMenu = $('.box-menu'),
			$iconeChat = $('#intercom-launcher');

		if ($boxMenu.hasClass('aberto')) {
		    // Entra aqui quando o menu fecha
			overlayMask.remove();
			$boxMenu.animate({
				right: -355
			}, 100);
			$boxMenu.removeClass('aberto');
			$iconeChat.stop(false, true).fadeIn(300);
			$('body').css('overflow', 'visible');
		} else {
			// Entra aqui quando o menu abre
			overlayMask.init();
			$boxMenu.animate({
				right: 0
			}, 100, function () {
				$(this).addClass('aberto');
				$iconeChat.stop(false, true).fadeOut(300);
			});
		}
	});

	/*
	 * Abre o menu quando EXISTE a classe "full-menu" no botão responsável por abrir o menu
	 */
	$(document).on('click', '.abrir-menu.full-menu', function (e) {
	    $('body').css('overflow', 'hidden');
	    e.preventDefault();
	    $('.abrir-menu').toggleClass('open');

		var $boxMenu = $('.box-menu');

		if ($boxMenu.hasClass('aberto')) {
			// Entra aqui quando o menu fecha
			overlayMask.remove();
			$boxMenu.fadeOut(100);
			$boxMenu.removeClass('aberto');
			$('body').css('overflow', 'visible');
		} else {
			// Entra aqui quando o menu abre
			overlayMask.init();
			$boxMenu.fadeIn(100, function () {
				$(this).addClass('aberto');
			});
		}
	});

	/*
	 * Fecha o menu quando o clica na fora do menu
	 */
	$(document).on('click', '.box-acoes .overlay-mask', function (e) {
	    $('.box-menu.aberto .abrir-menu').trigger('click');
	    $('body').css('overflow', 'visible');
	});

	/*
	 * Fecha o menu quando é pressionado o ESC
	 */
	$(document).keyup(function (e) {
		if (e.keyCode == 27) {
		    $('.box-menu.aberto .abrir-menu').trigger('click');
		    $('body').css('overflow', 'visible');
		}
	});

}(jQuery));